import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "flex-container" }
const _hoisted_4 = { class: "image-container header-img-container" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-container" }
const _hoisted_7 = { class: "subtitle" }
const _hoisted_8 = { class: "about-project" }
const _hoisted_9 = { class: "content-grid" }
const _hoisted_10 = { class: "text-block" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "highlight-box" }
const _hoisted_14 = { class: "stat-item" }
const _hoisted_15 = { class: "stat-text" }
const _hoisted_16 = { class: "stat-item" }
const _hoisted_17 = { class: "stat-text" }
const _hoisted_18 = { class: "stat-item" }
const _hoisted_19 = { class: "stat-text" }
const _hoisted_20 = { class: "role-details" }
const _hoisted_21 = { class: "tech-grid" }
const _hoisted_22 = { class: "tech-card" }
const _hoisted_23 = { class: "tech-text" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "tech-card" }
const _hoisted_27 = { class: "tech-text" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { class: "architecture-details" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { class: "tech-grid ai-grid" }
const _hoisted_34 = { class: "tech-card ai-card" }
const _hoisted_35 = { class: "tech-text" }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { class: "tech-card ai-card" }
const _hoisted_38 = { class: "tech-text" }
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = { class: "visuals-section" }
const _hoisted_41 = { class: "image-wrapper" }
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "technical-details" }
const _hoisted_44 = { class: "competencies-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfraCompetencyCard = _resolveComponent("InfraCompetencyCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: require('@/assets/image/CGJ2024-Affiche-8eme-edition.jpg'),
            alt: "Affiche Code Game Jam",
            class: "header-image",
            loading: "lazy"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('cgj.title')), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('cgj.subtitle')), 1)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('cgj.aboutTitle')), 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", {
            innerHTML: _ctx.$t('cgj.intro1')
          }, null, 8, _hoisted_11),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('cgj.intro2')
          }, null, 8, _hoisted_12)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "mdi mdi-timer-outline stat-icon" }, null, -1)),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('cgj.statTime')), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "mdi mdi-account-group-outline stat-icon" }, null, -1)),
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('cgj.statTeam')), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "mdi mdi-controller stat-icon" }, null, -1)),
            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('cgj.statType')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_20, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('cgj.roleTitle')), 1),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "mdi mdi-cube-outline tech-icon" }, null, -1)),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('cgj.roleArch')), 1),
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                innerHTML: _ctx.$t('cgj.role1')
              }, null, 8, _hoisted_24),
              _createElementVNode("li", {
                innerHTML: _ctx.$t('cgj.role2')
              }, null, 8, _hoisted_25)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "mdi mdi-brain tech-icon" }, null, -1)),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('cgj.roleAi')), 1),
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                innerHTML: _ctx.$t('cgj.role3')
              }, null, 8, _hoisted_28),
              _createElementVNode("li", {
                innerHTML: _ctx.$t('cgj.role4')
              }, null, 8, _hoisted_29)
            ])
          ])
        ])
      ]),
      _createElementVNode("p", {
        class: "conclusion-text",
        innerHTML: _ctx.$t('cgj.conclusion')
      }, null, 8, _hoisted_30)
    ]),
    _createElementVNode("section", _hoisted_31, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('cgj.aiTitle')), 1),
      _createElementVNode("p", {
        class: "intro-text",
        innerHTML: _ctx.$t('cgj.aiIntro')
      }, null, 8, _hoisted_32),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "mdi mdi-map-marker-path tech-icon" }, null, -1)),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("p", {
              innerHTML: _ctx.$t('cgj.aiNavmesh')
            }, null, 8, _hoisted_36)
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "mdi mdi-radar tech-icon" }, null, -1)),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("p", {
              innerHTML: _ctx.$t('cgj.aiCollider')
            }, null, 8, _hoisted_39)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_40, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('cgj.imageTitle')), 1),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("img", {
          src: require('@/assets/image/cgj-preview-jeu.png'),
          alt: "Capture d'écran du jeu",
          class: "doc-image",
          loading: "lazy"
        }, null, 8, _hoisted_42)
      ])
    ]),
    _createElementVNode("section", _hoisted_43, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('cgj.learningsTitle')), 1),
      _createElementVNode("div", _hoisted_44, [
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-lightning-bolt-outline",
          title: "Gestion du Stress",
          description: _ctx.$t('cgj.learning1')
        }, null, 8, ["description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-github",
          title: "Git Collaboratif",
          description: _ctx.$t('cgj.learning2')
        }, null, 8, ["description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-controller",
          title: "Game Development",
          description: _ctx.$t('cgj.learning3')
        }, null, 8, ["description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-account-group-outline",
          title: "Coordination d'Équipe",
          description: _ctx.$t('cgj.learning4')
        }, null, 8, ["description"])
      ])
    ])
  ]))
}